import { ERP } from '../_base/endpoint';
import global from '../../common/utility/global';
import axios from 'axios';

class impresionEtiquetaService {
    
    /******* QUERIES ******/


    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/impresion-etiqueta/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async excel(filter) {
        const response = await axios
            .get(`${ERP}administracion/impresion-etiqueta/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async pdf(filter) {
        const response = await axios
            .get(`${ERP}administracion/impresion-etiqueta/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async etiqueta(filter) {
        const response = await axios
            .get(`${ERP}administracion/impresion-etiqueta/etiqueta?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/


}

export default new impresionEtiquetaService();